import { useState } from "react";
import { useMutation } from "react-query";
interface MutationFunction {
  (data: any): Promise<any>;
}

interface UseMutationOptions {
  onMutate?: () => void;
  onSuccess?: (data: any, variables?: any) => void;
  onError?: (error: any) => void;
  onSettled?: (data: any, error: any) => void;
}

export enum MUTATION_STATUS {
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
  IDLE = "idle",
}

export default function useStatusMutation(
  mutationFn: MutationFunction,
  mutationOption: UseMutationOptions
) {
  const [status, setStatus] = useState<MUTATION_STATUS>(MUTATION_STATUS.IDLE);
  const loading: boolean = status === MUTATION_STATUS.LOADING;
  const success: boolean = status === MUTATION_STATUS.SUCCESS;
  const error: boolean = status === MUTATION_STATUS.ERROR;
  const idle: boolean = status === MUTATION_STATUS.IDLE;
  const mutation = useMutation(mutationFn, {
    ...mutationOption,
    onMutate: () => {
      setStatus(MUTATION_STATUS.LOADING);
      mutationOption.onMutate && mutationOption.onMutate();
    },
    onSuccess: (data: any) => {
      setStatus(MUTATION_STATUS.SUCCESS);
      setTimeout(() => setStatus(MUTATION_STATUS.IDLE), 200);
      mutationOption.onSuccess && mutationOption.onSuccess(data);
    },
    onError: (err: any) => {
      setStatus(MUTATION_STATUS.ERROR);
      setTimeout(() => setStatus(MUTATION_STATUS.IDLE), 200);
      mutationOption.onError && mutationOption.onError(err);
    },
    onSettled: (data: any, error: any) => {
      mutationOption.onSettled && mutationOption.onSettled(data, error);
    },
  });
  return { ...mutation, status, loading, success, error, idle };
}
